import React, { useState, useEffect, useContext, useMemo } from 'react'
import axios from 'axios'
import { DispatchContext, StateContext } from '../../AppContext'
import { IState, ParamTypes } from 'src/Interface'
import { useLocation, useParams } from 'react-router-dom'
import { baseApiURL } from 'src/utils/utils'
import Header from 'src/components/header/Header'
import Button from 'src/components/button/Button'
import { usePagination, useSortBy, useTable, useGlobalFilter } from 'react-table'
import { toast } from 'react-toastify';
import SearchField from 'src/components/searchField/SearchField'
import Footer from 'src/components/footer/Footer'
import SubHeader from 'src/components/subHeader/SubHeader'
import Table from 'src/components/table/Table'


const Accounts: React.FunctionComponent = () => {
  const state: IState = useContext(StateContext)
  const [loading, setLoading] = useState(true)
  const location: any = useLocation()
  const dispatch = useContext(DispatchContext)
  const { companyId } = useParams<ParamTypes>()

  const data = useMemo(() => state.accounts, [state.accounts])
  const columns = useMemo(() => [
    {
      Header: 'Navn',
      accessor: 'name',
      Cell: cell => cell.row.original.defaultAccount ? <span className='tw-flex tw-items-center'><svg data-title='test' xmlns="http://www.w3.org/2000/svg" className={`tw-h-5 tw-w-5 tw-mr-2`} viewBox="0 0 20 20" fill="currentColor">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg> {cell.value}</span> : cell.value
    },
    {
      Header: 'Konto-kode',
      accessor: 'code',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: (cell) => cell.value === 'ACTIVE' ? <span className='status status--green'>Aktiv</span> : <span className='status status--red'>Inaktiv</span>
    }
  ], [])


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    canNextPage,
    canPreviousPage,
    pageOptions,
    previousPage,
    gotoPage,
    state: pageState,
    setGlobalFilter,
    nextPage,
    prepareRow,
  } = useTable({
    columns,
    data,
    autoResetPage: false
  }, useGlobalFilter, useSortBy, usePagination)

  useEffect(() => {
    if (state.user.accessToken && companyId) {
      axios.get(`${baseApiURL()}/companies/${companyId}/accounts`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
        .then((result) => {
          setLoading(false)
          dispatch({ type: 'SET_ACCOUNTS', accounts: result.data })
        }).catch((err) => {
          toast(<svg className='tw-w-5 tw-h-5 tw-mr-3' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg> + err.response.data.message)
          setLoading(false)
        })
    }
  }, [companyId, dispatch, state.user.accessToken])

  return (
    <>
      <Header />
      <SubHeader loading={loading}
        backPath={location.state ? location.state.backPath : '/companies'}
        title={
          <>
            <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg> <span className='color-gray tw-font-normal'>{location.state ? location.state.from : 'Indstillinger'}</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span> <span className='text-black text-bold'>Konto</span>
          </>
        }>
        <SearchField name='search' label='Søg' placeholder='Søg' handleInputChange={(value) => setGlobalFilter(value)} />
        <Button modifiers='tw-ml-5' type='primary' label='Opret konto' handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addAccount', companyId })} />
      </SubHeader>
      <main className='container'>
        <Table
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          prepareRow={prepareRow}
          handleClick={(accountId) => dispatch({ type: 'SHOW_ASIDE', asideType: 'AccountsDetails', show: true, accountId, companyId, size: 'small' })}
          loading={loading}
          page={page}
          headerGroups={headerGroups}
          type='accounts'
          companyId={companyId}
          state={{ background: location }}
        />
      </main>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        page={page}
        loading={loading}
        gotoPage={gotoPage}
        paginationLabel='konto'
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={state.accounts.length}
      />
    </>
  )
}

export default Accounts
